import { useEffect } from 'react';

/**
 * Locks body scroll while `enabled` is true. Restores the previous
 * `overflow` value (not just `''`) so nested modals don't unlock too early.
 */
export function useBodyScrollLock(enabled: boolean): void {
  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return;
    }
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, [enabled]);
}
